import gql from 'graphql-tag';

export class ContentTagQueries {
  static load = gql`
    query dealroomResourceTagCategories($limit: Int, $offset: Int) {
      dealroomResourceTagCategories(limit: $limit, offset: $offset) {
        categories {
          id
          name
          tags {
            id
            name
          }
        }
      }
    }
  `;

  static loadTagResourceCount = gql`
    query dsrResourceTagsCount {
      dsrResourceTagsCount {
        tagsCount {
          tagId
          count
        }
      }
    }
  `;
}
